import { ref } from 'vue';
import { ENDPOINTS, upsCountries } from '~/helpers/ups';

const useUPS = () => {
  const locations = ref([]);

  const isLocationsLoading = ref(false);

  // Этот запрос ловит роут server/routes/ups и отправляет ups.
  // `$fetch`, а не `$httpClient`: `/ups/**` — это Nitro-роуты самого приложения,
  // им не нужен базовый адрес CMS.
  // Access-токен UPS остаётся на сервере, поэтому отсюда уходит только адрес.
  // Из полученных локаций формируются объекты которые используются
  // в ServiceForm, house_number связан с "" потому что у UPS
  // номер дома попадает в street из location.AddressKeyFormat.AddressLine,
  // а у DPD есть отдельное поле для него, но они оба используются
  // в функции getFullAddressStringFromAddressObj при формировании строки fullAddress,
  // которая независимо от типа deliveryAgent использует house_number
  const getLocations = async (addressInfo: any) => {
    const countryCode = upsCountries?.find(
      (upsCountry: any) => upsCountry.id === addressInfo.country,
    )?.id;
    isLocationsLoading.value = true;
    try {
      const data = await $fetch(`/ups${ENDPOINTS.getLocations}`, {
        method: 'POST',
        body: {
          data: {
            addressLine: addressInfo.addressLine,
            city: addressInfo.city,
            postalCode: addressInfo.postalCode,
            countryCode,
            state: addressInfo.state,
          },
        },
      });

      locations.value = data.LocatorResponse.SearchResults.DropLocation.map(
        (location: any) => {
          return {
            city: location.AddressKeyFormat.PoliticalDivision2,
            postcode: location.AddressKeyFormat.PostcodePrimaryLow,
            street: location.AddressKeyFormat.AddressLine,
            house_number: '',
          };
        },
      );
    } catch (e) {
      console.error(e);
      locations.value = [];
    } finally {
      isLocationsLoading.value = false;
    }
  };

  return {
    getLocations,
    locations,
    isLocationsLoading,
    upsCountries,
  };
};

export default useUPS;
